/** Extract a useful message from native and PostgREST error values. */
export function errorMessage(error: unknown, fallback = 'Неизвестная ошибка'): string {
  if (!error) return fallback
  if (error instanceof Error && error.message.trim()) return error.message.trim()
  if (typeof error === 'string' && error.trim()) return error.trim()

  if (typeof error === 'object') {
    const value = error as { message?: unknown; details?: unknown; hint?: unknown; code?: unknown }
    const parts = [value.message, value.details, value.hint]
      .filter((part): part is string => typeof part === 'string' && part.trim().length > 0)
      .map(part => part.trim())
    if (parts.length > 0) return parts.join(' | ')
    if (typeof value.code === 'string' && value.code.trim()) return value.code.trim()
  }

  return fallback
}
